const REG_HEX_COLOR = /^#[0-9a-f]{3,6}$/i

export function upgrade(userSettings) {
  
  const {favorites} = userSettings
  favorites.colors = favorites.colors ?
    favorites.colors.filter(color => (typeof color === 'string' && REG_HEX_COLOR.test(color)))
    : []
}

export const DEFAULT_SETTINGS = {
  trialActivatedMessageSeen: false,
  isLiked: false,
  isQuickMenuShown: false,
  tips: {
    version: 0
  },
  favorites: {
    fonts: [],
    colors: []
  },
  preferences: {
    autoConfirmSwapVideo: false
  },
  newFeatures: {
    'character-builder': {
      dismissedTimestamp: undefined,
      viewState: 'new'
    }
  }
}
